var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "#78B400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.875 59.0987L32.0554 50.2791C31.0641 49.2879 29.4629 49.2879 28.4716 50.2791C27.4804 51.2704 27.4804 52.8716 28.4716 53.8629L39.0958 64.4871C40.0871 65.4783 41.6883 65.4783 42.6796 64.4871L69.5704 37.5962C70.5617 36.605 70.5617 35.0037 69.5704 34.0125C68.5792 33.0212 66.9779 33.0212 65.9866 34.0125L40.875 59.0987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.55b8db9307e840c00ffa60e889b730a3.svg";
export { ForwardRef as ReactComponent };